import React, {useEffect,  useState} from 'react';
import styled from 'styled-components';
import {Dialog, Button} from '@zebra-fed/zds-react-desktop';
import '@zebra-fed/icons/Alert/index.css';
import {useTranslation} from "react-i18next";
import { Item } from '@zebra-fed/zds-react-desktop/components';
import CSVImport from '../../pages/CsvImport';
import CSVImportAccessories from '../../pages/CsvImportAccessories';
import ApsCSVImport from '../../pages/ApsCsvImport';
import SitesCSVImport from '../../pages/SitesCsvImport';
import { CircularProgress } from '@material-ui/core';

const CheckboxComp = styled.div`
    display: flex;
    align-items: center;
    margin-left: -8px;
    font-size: 20px;
`;

const ModalHeader = styled.div`
    display: flex;
    flex-direction: row;
    height: 50px;
    font-size: 18px;
    background-color: #007ABA;
    color: white;
    align-items: center;
    padding: 0 24px;    
    justify-content: center;
`

const MainContent = styled.div`
  margin-top: 0;
  display: flex;
  flex-direction: column;
  align-items: inital;
  padding: 20px 20px;
  line-height: normal;
`;

const ButtonContainer = styled.div`
    display: flex;
    max-width: 500px;
    justify-content: end;
`;

export default function CsvCompModal(props) {
    const { importType, ConfigData, deviceRegistrationType,
        refreshPage = () => { }, onCancelHit = () => {} } = props;

    const dialogRef = props.modalRef;
    const { t } = useTranslation();
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    function handleCancel() {
        dialogRef.current.toggleDialog();
        onCancelHit();
        // clearForm();
    }

    const ButtonStyle = {
        cursor: isLoading ? 'wait' : 'pointer',
    }

    return (
        <div className='import-modal'>
            <Dialog 
                ref={dialogRef}
                key='dialog2'
                width='520px'  
                headerStyle={{display: 'none' }}
                bodyStyle={{padding: '0px', width: '100%'}}
                cardStyle={{ marginBottom: '80px'}}
                style={{cursor: isLoading ? 'wait' : 'default'}}>
                <MainContent
                 style={{ cursor: "default", opacity: '1' }}
                >
                    <h4 style={{margin: '0px'}}>{importType?.name}</h4>
                    <p style={{fontSize: '13px'}}>{importType?.description?importType.description:t('csvModal.UploadCsv')}</p>
                    { 
                    importType?.page === 'APS' ? <ApsCSVImport 
                    cancelClicked={() => handleCancel()} 
                    importType={importType} 
                    ConfigData={ConfigData}
                    refreshPage={refreshPage}
                    /> :   importType?.page === 'SITE' ? 
                    <SitesCSVImport 
                    cancelClicked={() => handleCancel()} 
                    importType={importType} 
                    ConfigData={ConfigData} 
                    deviceRegistrationType = {deviceRegistrationType}
                    refreshPage={refreshPage}
                    />:   importType?.page === 'LICENSES' ? 
                    <CSVImportAccessories 
                    cancelClicked={() => handleCancel()} 
                    importType={importType} 
                    ConfigData={ConfigData} 
                    deviceRegistrationType = {deviceRegistrationType}
                    refreshPage={refreshPage}
                    />
                        :
                    <CSVImport cancelClicked={() => handleCancel()} 
                    importType={importType} 
                    ConfigData={ConfigData}
                    refreshPage={refreshPage}
                    />
                }
                </MainContent>
            </Dialog>
        </div>
    )
}